import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import CountUp from 'react-countup';


import _ from "lodash";

import axios from 'axios';
import { AgGridReact } from '@ag-grid-community/react';
import {AllModules} from '@ag-grid-enterprise/all-modules';
//import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';

import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
//import Grid from '../layouts/gridnosidebarComponent';

import CustomLoadingCellRenderer from "../layouts/customLoadingCellRenderer";
import KpiTransitDelayActions from './kpiTransitDelayActions';
import Notransit from './notransitComponent.js';
import ConsignmentActions from './routemapComponent';
import ConsignmentNoActions from './routemapNoComponent';
import ExportsHighSeasAction from './exportshighseasaction';
import ConsignmentImportsNoEventsAction from './consignmentimportsnoEventAction';

import ExportsPortAction from './exportsinportaction';
import ExportsIcdToPortAction from './exportsicdtoportaction';
import ExportsIcdToMsilAction from './exportsicdtomsilaction';
import ExportsMsilToIcdAction from './exportsmsiltoicdaction';
import ExportsInIcdAction from './exportsinicdaction';
import ImportsEmptyContainerAction from './importsemptycontaineraction';
import Forceclose from './exportsforcecloseaction';
import Criticalaction from './exportscontainercriticalaction';
//import Counters from '../layouts/consignmentimportscountersComponent';
import ExportsConsignmentsCounters from '../layouts/exportsconsignmentscounters.component';
import 'react-vertical-timeline-component/style.min.css';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getYYYYMMDDHHMMSS,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY, getDDMMMYYYY } from '../common/utils'; 
import DrawMap from '../common/drawmap';
import Breadcrumb from '../common/breadcrumb.component';

import Modal from 'react-responsive-modal';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import Select from 'react-select';
var moment = require('moment');
 
var redirectURL = require('../redirectURL');

var infoBox = require('../common/google-infowindow');

const fs = require('fs');
var googleAnalytics = require("../common/googleanalytics");

 
var drawingManager;
var selectedShape;
var colors = ['#1D9567', '#1692A5', '#F4D749','#F73E3E', '#B7B3B3' ];
var selectedColor;
var colorButtons = {};
var fencingLength=0;
var mapZoom=12;
var coordinates=[];
var geoFencingArea;

export default class ManageExportsConsignments extends Component {

	constructor(props){
		super(props);
		this.state={
			pageTitle: "Container Exports (High Sea)",
			eventGridAction: "gridAction",
			eventCounterAction: "counterAction",
			
			totalConsignmentsCount: 0,

			inTransitToMsilData: null,
			inTransitToMsilCount: 0,

			inTransitToIcdData: null,
			inTransitToIcdCount:0,

			insideIcdData: null,
			insideIcdCount: 0,

			inTransitToPortData: null,
			inTransitToPortCount: 0,

			highSeasData: null,
			highSeasCount: 0,

			
			insidePortData: null,
			insidePortCount: 0,

			deliveredData: null,
			deliveredCount: 0,

			consignmentStatus: null,
			statusTexts: [],

			uploadDivWidth:'0%',
			sliderTranslate:'',
			sliderRouteTranslate:'',
			tabsliderTranslate:'',
			timelineinfo:'',
			consignment_code:'',
			mapinfo:'',
			loadshow:'show-n',
			showDiv:'show-n',
			alertshow:'fade',
			alertmg:'show-n',
			alerterrmg:'show-n',
			alerterrshow:'fade',
			overly:'show-n',
			alert:null,
            show: false,
            basicTitle:'',
			basicType:"default",
			modules: AllModules,
			filterstatess:{},
      	    columnsdatas:{},
      	    rowgroupdcols:[],
      	    valuecolumns:[],
      	    pivotmodeis:false,
			pivotcols:[],
			defTransitCoords:'',
			allRowData:0,
			highseascount:0,
			inportcount:0,
			

			inicdcount:0,
			transitmsilcount:0,
      	    defaultColDef: {
      	    	sortable: true,
				filter: true,
				resizable: true,
				

      	    },
      	    rowData: null,
			headerHeight: 40,
			groupHeaderHeight:60,
      	    rowModelhighchartoptionsType: 'enterprise',
			  rowGroupPanelShow: 'always',
			  frameworkComponents: {
                customLoadingCellRenderer: CustomLoadingCellRenderer,
				consignmentActions:ConsignmentActions,
				consignmentNoActions:ConsignmentNoActions,
				exportsHighSeasAction: ExportsHighSeasAction,
				ConsignmentImportsNoEventsAction:ConsignmentImportsNoEventsAction,
				exportsPortAction:ExportsPortAction,
				exportsIcdToPortAction:ExportsIcdToPortAction,
				exportsIcdToMsilAction:ExportsIcdToMsilAction,
				exportsMsilToIcdAction:ExportsMsilToIcdAction,
				exportsInIcdAction:ExportsInIcdAction,
				importsEmptyContainerAction:ImportsEmptyContainerAction,
				forceclose:Forceclose,
				criticalaction:Criticalaction
			},

      	    animateRows: true,
      	    debug: true,
      	    showToolPanel: false,
			uppressAggFuncInHeader: true,
				
			childconfs: [],
			childrow:[],
			rowModelType: "serverSide",
			paginationPageSize:100,
			cacheBlockSize: 10,
			maxBlocksInCache: 1,
			statusBar: {
				statusPanels: [
					{
					statusPanel: "agTotalAndFilteredRowCountComponent",
					align: "left"
					},
					{
					statusPanel: "agTotalRowCountComponent",
					align: "center"
					},
					{ statusPanel: "agFilteredRowCountComponent" },
					{ statusPanel: "agSelectedRowCountComponent" },
					{ statusPanel: "agAggregationComponent" }
				]
			},
			sideBar: {
				toolPanels: [
					{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel"
					},
					{
					id: "filters",
					labelDefault: "Filters",
					labelKey: "filters",
					iconKey: "filter",
					toolPanel: "agFiltersToolPanel"
					}
				]
			},
			rowClassRules: {
				"highlitRow": "data.transit_delay == 1",
				"cellStyleGrid":"columnApi.columnController.columnDefs[0].headerName == 'High Sea Details'",
				//"d-none": "data.last_status == 'Empty Returned'"
			},
			podlist:[],
			pod:'',
			startDate:'',
			endDate:'',
			criteria:'',
			errStyCriteria:'',
			errStyPod:'',
			errStyPol:'',
			errStyStartDate:'',
			errStyEndDate:'',
			pollist:[],
			pol:'',
			open: false,
			opencritical:false,
			forceclose_remarks:'',
			forcedata:[],
			criticalrowdata:[],
			pod_ata:'',
			critical_deliver_date:'',
			truck_no:'',
			usergridstate:[],
			screenurl:"",
			screentitle:"",
			tolls : []
			
		}
	
		this.onShowRouteMap = this.onShowRouteMap.bind(this);
		this.compare_dates = this.compare_dates.bind(this);
		
	}

	getStatusText(status) {
		let consignmentStatus = null;
		switch(status) {
			case 1:
				//console.log("CASE 1 = ", status);
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 3:
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 4:
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 5:
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 6:
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 7:
				consignmentStatus = this.state.statusTexts[status];
				break;
			case 8:
				consignmentStatus = this.state.statusTexts[status];
				break;
			default:
				console.log("CASE Default = ", status);
				consignmentStatus = "All"
				break;
		}

		//console.log("CASE consignmentStatus = ", consignmentStatus);
		
		return consignmentStatus;
	}
	componentDidMount(){
		try {
			if (googleAnalytics.page.enableGA) {
				googleAnalytics.logPageView();
				let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
				let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
				this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction});
			} else {
				console.log("GA disabled...");
			}
		} catch(error) {
			console.error("Error occured while logging to GA, error = ", error);
		}
		
		redirectURL.post("/consignments/usergridstates",{userId:localStorage.getItem("userid"),screenurl:window.location.pathname})
		.then( async (resp) => {
			await this.setState({
				usergridstate:resp.data
			});
			await this.restoreGridStates();
		})
		redirectURL.post("importscoils/pods")
		.then((response) =>{
			this.setState({
				podlist:response.data
			});
		})
		.catch(function(e){
			console.log("Error ", e)
		})


		redirectURL.post("importscoils/pols")
		.then((response) =>{
			this.setState({
				pollist:response.data
			});
		})
		.catch(function(e){
			console.log("Error ", e)
		})
		let statusTexts = {
			"1": "ICD to MSIL",
			"3": "MSIL to ICD",
			"4": "Inside ICD",
			"5": "ICD to Port",
			"6": "Inside Port",
			"7": "High Seas",
			"8": "Delivered"
		}
		this.setState({
			statusTexts:statusTexts,
		});
		 /*Consignments List*/	

		 var urlpath;
		
		if(this.props.match.path == "/exports/consignments")
		{
			urlpath = '/exports/consignments';
			this.setState({
				pageTitle:"Container Exports (Supply Chain)"
			});
		}
		if(this.props.match.path == "/exports/adaniconsignments")
		{
			urlpath = '/exports/adaniconsignments';
			this.setState({
				pageTitle:"Container Exports (Spare Parts)"
			});
		}
		
		redirectURL.post(urlpath)
		    .then((response) => {
				var records = response.data;
				// console.log(records)
				console.log(records.filter(function(params){return params.gps_msil_gate_out}))
				records.map(rec => {
					if (rec.icd_source) {
						rec.icd_source = rec.icd_source.toUpperCase();
					}  
					if (rec.status) {
						rec.statusText = this.getStatusText(rec.status);
						//console.log("IN  rec.statusText = ",rec.statusText);
					}  
				})
				//console.log("IN EXPORTS , records = ", records, records.length);
				this.setState({
					rowData:records,
					allRowData:records,
				});

				// calculate counters
				let totalConsignmentsCount  = 0;

				let inTransitToMsilData  = null;
				let inTransitToMsilCount  = 0;

				let inTransitToIcdData  = null;
				let inTransitToIcdCount  = 0;

				let insideIcdData  = null;
				let insideIcdCount  = 0;

				let inTransitToPortData  = null;
				let inTransitToPortCount  = 0;

				let insidePortData  = null;
				let insidePortCount  = 0;

				let highSeasData  = null;
				let highSeasCount  = 0;

				let deliveredData  = null;
				let deliveredCount  = 0;

				totalConsignmentsCount = (records) ? records.length : 0;

				inTransitToMsilData = records.filter(rec => rec.status == 1);
				inTransitToMsilCount = (inTransitToMsilData) ? inTransitToMsilData.length : 0;

				inTransitToIcdData = records.filter(rec => rec.status == 3);
				inTransitToIcdCount = (inTransitToIcdData) ? inTransitToIcdData.length : 0;

				insideIcdData = records.filter(rec => rec.status == 4);
				insideIcdCount = (insideIcdData) ? insideIcdData.length : 0;

				inTransitToPortData = records.filter(rec => rec.status == 5);
				inTransitToPortCount = (inTransitToPortData) ? inTransitToPortData.length : 0;

				insidePortData = records.filter(rec => rec.status == 6);
				insidePortCount = (insidePortData) ? insidePortData.length : 0;

				highSeasData = records.filter(rec => rec.status == 7);
				highSeasCount = (highSeasData) ? highSeasData.length : 0;

				deliveredData = records.filter(rec => rec.status == 8);
				deliveredCount = (deliveredData) ? deliveredData.length : 0;

				//console.log("inTransitToMsilData = ", inTransitToMsilData, inTransitToMsilCount);

				this.setState({
					totalConsignmentsCount: totalConsignmentsCount,

					inTransitToMsilData: inTransitToMsilData,
					inTransitToMsilCount: inTransitToMsilCount,

					inTransitToIcdData: inTransitToIcdData,
					inTransitToIcdCount: inTransitToIcdCount,
		
					insideIcdData: insideIcdData,
					insideIcdCount: insideIcdCount,
		
					inTransitToPortData: inTransitToPortData,
					inTransitToPortCount: inTransitToPortCount,
		
					insidePortData: insidePortData,
					insidePortCount: insidePortCount,

					highSeasData: highSeasData,
					highSeasCount: highSeasCount,

					deliveredData: deliveredData,
					deliveredCount: deliveredCount,


				});

				//console.log("This state = ", this.state);


			})
		    .catch(function(error) {
		    	console.log(error);
			});
			
	   
	};
	
	
	logPageView = () => {
		try {
		    if (googleAnalytics.page.enableGA) {
		        googleAnalytics.logPageView();
		        let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
		        let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
		        let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
		        this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
		    } else {
		        console.log("GA disabled...");
		    }
		} catch(error) {
		    console.error("Error occured while logging to GA, error = ", error);
		}
    }

	
	onGridReady = params => {
	    this.gridApi = params.api;
	    //console.log("Grid is: ", this.gridOptionsWrapper);
	    this.gridColumnApi = params.columnApi;
	
	   //    ChartMenu.prototype.saveChart = function (e) {
	// 	   var event = {
	// 	      data: this.gridOptionsWrapper.getApi(),
	// 	      type: ChartMenu.EVENT_DOWNLOAD_CHART
	// 	    };
	// 	   //console.log("Testing", event);
	// 	  // console.log("hart Cell Ranges : ", event.data.chartService.rangeController.cellRanges)
	// 	   this.dispatchEvent(event);
	// 	   var chrtdata = event.data.chartService.rangeController.cellRanges;
		   
	//    };
	   
	};
	

	onGridState = () =>{
		 //console.log(this.gridApi);
		
		 /*Get  Current Columns State and Store in this.colState */
		   this.colState = this.gridColumnApi.getColumnState();

		 /*Get Current RowGroup Columns State and Store in this.rowGroupState */
		   this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

		 /*Get Current Pivot Columns State and Store in this.pivotColumns, 
		  * User should enable the Pivot mode.*/
		   this.pivotColumns = this.gridColumnApi.getPivotColumns();
		 		   
		 /*Get Current Filter State and Store in window.filterState */
		   window.filterState = this.gridApi.getFilterModel();
		   this.gridApi.setFilterModel(window.filterState);
		   
	}

	renderMap = () => {    	
		//loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBQUmk7hdajZEAYllxKhVPnUx5pXuK-j_Y&libraries=places,drawing&callback=initMap");
		//window.initMap = this.initMap
	}
	
	initMap = () => {
    	//console.log(this.state.allmarkers);
    	var currentwindow;
    	var jsondata = this.state.mapinfo;
    	var locations = jsondata.points;
        var arr = jsondata.route;
		//console.log("Here",arr);
		if(arr.length > 0)
		{
			var lt=arr[0].lat;
			var ln=arr[0].lng;
		}
		else{
			//console.log("defTransitCoords ", JSON.parse(this.state.defTransitCoords));
			var lt=JSON.parse(this.state.defTransitCoords).lat;
			var ln=JSON.parse(this.state.defTransitCoords).lng;
		}
    	 var mapOptions = {
    			zoom: 7,
				zoomControl: true,
				mapTypeControl: true,
				scaleControl: true,
				streetViewControl: true,
				rotateControl: true,
				fullscreenControl: true,
    	          labels:true,
    	          mapTypeControlOptions: {
    	            mapTypeIds: ['hybrid', 'roadmap'],
    	          },
    	          center: new window.google.maps.LatLng(lt,ln),
    	          mapTypeId: window.google.maps.MapTypeId.ROADMAP
    	        };
    	        
    	        var map = new window.google.maps.Map(document.getElementById('map'),
    	            mapOptions);

				var bounds = new window.google.maps.LatLngBounds();
				bounds.extend(new window.google.maps.LatLng(lt,ln));
    			 // Create our info window content
    			var currentinfowindow = null;
    	       var line=new window.google.maps.Polyline(
    	              {
    	                map:map,
    									strokeColor: '#157254',
    									strokeOpacity: 1.0,
    									strokeWeight: 2.5,
    	                		icons: [{
    	                          icon: {
    	                                  path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    	                                  strokeColor:'#ff8c52',
    	                                  fillColor:'#ff8c52',
    	                                  fillOpacity:1,
    									  strokeWeight: 2
    	                                },
    	                          repeat:'100px',
    	                          path:[]
    	                       }]
    	                 });

			if(arr.length > 0)
			{	
    		  for (let i = 0; i < arr.length; i++) {
    				var path=line.getPath().getArray();
    					
    						let latLng=new window.google.maps.LatLng(arr[i].lat,arr[i].lng);
    						path.push(latLng);
    	          			line.setPath(path);
    					

    				  
    		  
    	          //Change line color based on map type
    	        window.google.maps.event.addListener( map, 'maptypeid_changed', function() {
    	            if (map.getMapTypeId() =='hybrid' || map.getMapTypeId() =='satellite')
    	            {
    	                var line=new window.google.maps.Polyline(
    	                  {
    	                    map:map,
    	                    strokeColor: '#FFFFFF',
    	                    strokeOpacity: 1.0,
    	                    strokeWeight: 2.5,
    	                    icons: [{
    	                              icon: {
    	                                      path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    	                                      strokeColor:'#ff8c52',
    	                                      fillColor:'#ff8c52',
    	                                      fillOpacity:1,
    	                                      strokeWeight: 2
    	                                    },
    	                              repeat:'100px',
    	                              path:[]
    	                           }]
    	                     });                
    	            }
    	            else
    	            {
    	                var line=new window.google.maps.Polyline(
    	                  {
    	                    map:map,
    	                    strokeColor: '#157254',
    	                    strokeOpacity: 1.0,
    	                    strokeWeight: 2.5,
    	                    icons: [{
    	                              icon: {
    	                                      path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    	                                      strokeColor:'#ff8c52',
    	                                      fillColor:'#ff8c52',
    	                                      fillOpacity:1,
    	                                      strokeWeight: 2
    	                                    },
    	                              repeat:'100px',
    	                              path:[]
    	                           }]
    	                     });

    	            }

    	              /*for (i = 0; i < arr.length; i++) {
    	                    var path=line.getPath().getArray();
    	                    let latLng=new window.google.maps.LatLng(arr[i].lat,arr[i].lng);
    						path.push(latLng);
    	          			line.setPath(path);
    	                            //map.setCenter(latLng);
						  }
						*/
    	                            
    	             var x = map.getZoom();
    	             var c = map.getCenter();
    	             window.google.maps.event.trigger(map, 'resize');
    	             map.setZoom(x);
					 map.setCenter(c);
					 
					 var path=line.getPath().getArray();
					let latLng=new window.google.maps.LatLng(arr[i].lat,arr[i].lng);
					path.push(latLng);
					line.setPath(path);
				} );
				
				bounds.extend(new window.google.maps.LatLng(arr[i].lat,arr[i].lng));
    		  }

		  var infowindow = new window.google.maps.InfoWindow();
			var marker, l;
			  //console.log("locations.length ", locations.length)
			  var lastorigin='';
			if(locations.length > 0)
			{
				for (l = 0; l < locations.length; l++) {
					if(arr[0].lat != locations[l].coordinates.lat && arr[0].lng != locations[l].coordinates.lmg)
					{
						marker = new window.google.maps.Marker({
						position: new window.google.maps.LatLng(locations[l].coordinates.lat, locations[l].coordinates.lng),
						icon:require('../../assets/icons/boat.png'),
						map: map,
						});

						window.google.maps.event.addListener(marker, 'click', (function(marker, l) {
							return function() {

								var contentarr = []
								var headerTitle = locations[l].name+", "+locations[l].country;
								//var contentString = "<p class='maptitle'>"+"<B> "+locations[l].name+", "+locations[l].country+"</B></p>";
								var contentStringData='';
								if(locations[l].events.length > 0)
								{
									contentStringData = contentStringData+"<table class='mt-8p table table-border' style='background:#f5f5f5;border:1px solid #dee2e6'>";
									contentStringData = contentStringData + "<thead><tr><th>Date</th><th>Event</th><th>Transport Mode</th></tr></thead><tbody>";
									for(var e=0;e<locations[l].events.length;e++)
									{
										var typemode;
										if(locations[l].events[e].type == 1){
											typemode='Rail/Truck';
										}
										if(locations[l].events[e].type == 2){
											typemode='Air';
										}
										if(locations[l].events[e].type == 3){
											typemode='Sea';
										}
										if(locations[l].events[e].type == 4){
											typemode='Rail/Truck';
										}
										var d = locations[l].events[e].event_datetime_ist;
										var dat = d.split(" ");				
										
										contentStringData = contentStringData + "<tr><td class='custb'><span class='tbmap'><i class='icofont icofont-disc'></i> <span class='tdmapsp'>"+ dat[0];
										contentStringData = contentStringData + "</span></td><td>" + locations[l].events[e].description + "</span></td><td style='text-align: right'>" + typemode + "</span></td></tr>";
										
				
									}
									contentStringData = contentStringData+"</tbody></table>";
									
								}
								contentarr.push(contentStringData);
							//lastorigin=contentString;
							//console.log("1", headerTitle)
							var contentString = infoBox(marker.icon, headerTitle, contentarr, 'table')
				

							infowindow.setContent(contentString);
							currentwindow = infowindow;
							infowindow.open(map, marker);
							//console.log(marker.position.toJSON());
							//console.log('{"lat":'+marker.position.lat() + ',"lng":' +marker.position.lng() +'}'); 
							}
						})(marker, l));
					}
					else{
						marker = new window.google.maps.Marker({
							position: new window.google.maps.LatLng(locations[l].coordinates.lat, locations[l].coordinates.lng),
							icon:require('../../assets/icons/start_port.png'),
							map: map,
							});
	
							window.google.maps.event.addListener(marker, 'click', (function(marker, l) {
								return function() {
									//var contentString = "<p class='maptitle'>"+"<B> "+locations[l].name+", "+locations[l].country+"</B></p>";
									var contentarr = []
									var headerTitle = locations[l].name+", "+locations[l].country;
									var contentStringData='';
									if(locations[l].events.length > 0)
									{
										contentStringData = contentStringData+"<table class='mt-8p table table-border' style='background:#f5f5f5;border:1px solid #dee2e6'>";
										contentStringData = contentStringData + "<thead><tr><th>Date</th><th>Event</th><th>Transport Mode</th></tr></thead><tbody>";
										for(var e=0;e<locations[l].events.length;e++)
										{
											var typemode;
											if(locations[l].events[e].type == 1){
												typemode='Rail/Truck';
											}
											if(locations[l].events[e].type == 2){
												typemode='Air';
											}
											if(locations[l].events[e].type == 3){
												typemode='Sea';
											}
											if(locations[l].events[e].type == 4){
												typemode='Rail/Truck';
											}
											var d = locations[l].events[e].event_datetime_ist;
											var dat = d.split(" ");											
											
											contentStringData = contentStringData + "<tr><td class='custb'><span class='tbmap'><i class='icofont icofont-disc'></i> <span class='tdmapsp'>"+ dat[0];
											contentStringData = contentStringData + "</span></td><td>" + locations[l].events[e].description + "</span></td><td style='text-align: right'>" + typemode + "</span></td></tr>";
	
										}
										contentStringData = contentStringData+"</tbody></table>";
										
									}
									contentarr.push(contentStringData);	
									//console.log("2", headerTitle)
									var contentString = infoBox(marker.icon, headerTitle, contentarr, 'table')
					
								infowindow.setContent(contentString);
								currentwindow = infowindow;
								infowindow.open(map, marker);
								//console.log(marker.position.toJSON());
								//console.log('{"lat":'+marker.position.lat() + ',"lng":' +marker.position.lng() +'}'); 
								}
							})(marker, l));
					}
				}
			}
			if (jsondata.hasOwnProperty('last_known_location') == true && jsondata.last_known_location != null)
			{
		   	    marker = new window.google.maps.Marker({
					position: new window.google.maps.LatLng(jsondata.last_known_location.lat, jsondata.last_known_location.lng),
					icon:require('../../assets/icons/crane.png'),
					map: map,	
				 
			  });
			

		   window.google.maps.event.addListener(marker, 'click', (function(marker) {
		        return function() {
		        	//console.log("jsondata", jsondata);
					var contentarr = []
					var headerTitle = "Last known location";
					var contentStringData='';
					var typemode;
					if(jsondata.last_event.type == 1){
						typemode='Rail/Truck';
					}
					if(jsondata.last_event.type == 2){
						typemode='Air';
					}
					if(jsondata.last_event.type == 3){
						typemode='Sea';
					}
					if(jsondata.last_event.type == 4){
						typemode='Rail/Truck';
					}
					var d = jsondata.last_event.event_datetime_ist;
					var dat = d.split(" ");
					
					var contentStringData = contentStringData+"<table class='mt-8p table table-border' style='background:#f5f5f5;border:1px solid #dee2e6'>";
					contentStringData = contentStringData + "<thead><tr><th>Last Updated Date</th><th>Transport Mode</th></tr></thead><tbody>";
					
					contentStringData = contentStringData + "<tr><td class='custb'><span class='tbmap'><i class='icofont icofont-disc'></i> <span class='tdmapsp'>"+ jsondata.last_known_time;
					contentStringData = contentStringData + "</span></td><td style='text-align: right'>" + typemode + "</td></tr>";
					contentStringData = contentStringData+"</tbody></table>";	
					
					contentarr.push(contentStringData);	
					var contentString = infoBox(marker.icon, headerTitle, contentarr, 'table')
					

				  infowindow.setContent(contentString);
				  currentwindow = infowindow;
				  infowindow.open(map, marker);
				 // console.log('{"lat":'+marker.position.lat() + ',"lng":' +marker.position.lng() +'}'); 
				}
			})(marker));
			}
		}
		map.fitBounds(bounds);

    }



	
	onShowRouteMap(rownode){
		//console.log("rownode = ", rownode);
		if (googleAnalytics.page.enableGA) {
			let eventOptions = {
				"category": this.state.pageTitle,
				"action": this.state.eventGridAction,
				"label": googleAnalytics.page.action.viewRoute,
			}
			googleAnalytics.logEvent(eventOptions);
		}
		

		if(rownode != 0)
		{
			if(typeof rownode.icd_gate_out == 'undefined')
			{
				if(typeof rownode.msil_gate_in == 'undefined')
				{
					if(typeof rownode.msil_gate_out == 'undefined')
					{
						var sdate = moment.parseZone(rownode.msil_gate_in).format("YYYY-MM-DD HH:mm:ss");
					}
				
				}
				else{
					var sdate = moment.parseZone(rownode.msil_gate_in).format("YYYY-MM-DD HH:mm:ss");
				}
			}
			else{
				var s = rownode.icd_gate_out;
				var sp = s.split(" ");
				//console.log(sp)
				var d = sp[0].split("-")
				var icd_dt = d[2]+"-"+d[1]+"-"+d[0]+" "+sp[1]
				var sdate = icd_dt;
				//var sdate = moment.parseZone(rownode.icd_gate_out).format("YYYY-MM-DD HH:mm:ss");
			}
			//console.log("rownode.icd_arrival_date ",rownode.icd_arrival_date)
			if(typeof rownode.icd_arrival_date != "undefined")
			{
				var edate = moment.parseZone(new Date(rownode.icd_arrival_date+" 23:59:59")).format("YYYY-MM-DD HH:mm:ss");
			}
			else{
				var edate = moment.parseZone(new Date()).format("YYYY-MM-DD HH:mm:ss");
			}

			var params = { 
				//container_no:"FSCU9842333"
				truck_no:rownode.trailer_no,
				start_date:sdate,
				end_date:edate
			}
			//console.log(params)
			this.setState({
				loadshow:'show-m'
			})
			//console.log("parmas ", params)
			 redirectURL.post('/imports/exportssearates',params)
			  .then((response) => {
			  
			   var records = response.data;
			   var check = JSON.parse(records.details);
				if(check.status == 'Failure' || check.status == "failure")
				{
					this.setState({
						show: true, 
						basicType:'danger', 
						basicTitle:"No data found",
						mapinfo:''	
					});
				}
				else{
					console.log("Map details ", JSON.parse(records.details))
					this.setState({
						mapinfo:JSON.parse(records.details),
						sliderRouteTranslate:"slider-translate-75p",
						consignment_code:rownode.container_no,
						truck_no:rownode.truck_no,
						show: false,
						overly:'show-m',
						tolls : records.tolls
					});
					//this.renderMap();
					
				}
				this.setState({
					loadshow:'show-n',
				})
			  })
			  .catch(function (error) {
				console.log(error);
			  });
			  
		}
		
	}
	onCloseRouteDiv = () => {
		this.setState({
			uploadDivWidth:'0%',
			sliderRouteTranslate:"",
			showDiv:'show-n',
			uploadFile:'',
			file:'',
			csvmessage:'',
			csverrmessage:'',
			overly:'show-n'
		});
	}
	closeAlert = () => {
        this.setState({
			show: false,
			overly:'show-n'
        });
	}
	onClickHideAll(){
		this.setState({
			loadshow:'show-n',
			overly:'show-n',
			sliderRouteTranslate:'',
			tabsliderTranslate:''
		});
		
	}
	compare_dates = (date1,date2) => {
		if (date1>date2) return 1; 
	 }

	onClickCounterShowData_OLD(params){
		console.log("Params Here ", params);

		if(params == 0)
		{
			this.setState({
				rowData:this.state.allRowData
			});
		}
		if(params == 1)
		{
			this.setState({
				rowData:this.state.highseascount
			});
		}
		if(params == 2)
		{
			this.setState({
				rowData:this.state.inportcount
			});
		}
		if(params == 3)
		{
			this.setState({
				rowData:this.state.inTransitToIcdCount
			});
		}
		if(params == 4)
		{
			this.setState({
				rowData:this.state.inicdcount
			});
		}
		if(params == 5)
		{
			this.setState({
				rowData:this.state.transitmsilcount
			});
		}
	}
	
	logCounterClickGA(params) {
		if (googleAnalytics.page.enableGA) {
			let statusText = this.getStatusText(params);
			let eventOptions = {
				"category": this.state.pageTitle,
				"action": this.state.eventCounterAction,
				"label": statusText,
			}
			googleAnalytics.logEvent(eventOptions);
		}
	}
	onClickCounterShowData(params){
		console.log("Counter Params Here ", params);
		this.logCounterClickGA(params); // Log Counter Actions for Google Analytics
		let selectedFilterData = null;
		switch(params) {
			case 1:
				selectedFilterData = this.state.inTransitToMsilData;
				//console.log("Case 1 params,", params, selectedFilterData);
				break;
			case 3:
				selectedFilterData = this.state.inTransitToIcdData;
				break;
			case 4:
				selectedFilterData = this.state.insideIcdData;
				break;
			case 5:
				selectedFilterData = this.state.inTransitToPortData;
				break;
			case 6:
				selectedFilterData = this.state.insidePortData;
				break;
			case 7:
				selectedFilterData = this.state.highSeasData;
				break;
			case 8:
					selectedFilterData = this.state.deliveredData;
					break;
			default:
				selectedFilterData = this.state.allRowData;
				break;
		}
		this.setState({
			rowData: selectedFilterData
		});

	}


	getPolListItems = pol =>{
        this.setState(
	      { pol },
	      () => console.log(this.state.pol)
        );
        
        this.setState({
			errorMessage:'',
			successMessage:''
        })
	}


	selectPolOptionsItems(){
        let items = [];     
		//items.push({value:'all',label:'All'}); 
		this.state.pollist.forEach(item =>{
			//console.log("pod ",item)
			items.push({value:item,label:item}); 
		}); 
        return items;
	}


	getPodListItems = pod =>{
        this.setState(
	      { pod },
	      () => console.log(this.state.pod)
        );
        
        this.setState({
			errorMessage:'',
			successMessage:''
        })
	}


	selectPodOptionsItems(){
        let items = [];     
		//items.push({value:'all',label:'All'}); 
		this.state.podlist.forEach(item =>{
			//console.log("pod ",item)
			items.push({value:item,label:item}); 
		});
        //items.push({value:"DEENDAYAL",label:"DEENDAYAL"}); 
        return items;
	}

	getCriteriaListItems = criteria =>{
        this.setState(
	      { criteria },
	      () => console.log(this.state.criteria)
        );
        
        this.setState({
			errorMessage:'',
			successMessage:''
        })
	}


	selectCriteriaOptionsItems(){
        let items = [
			//{value:'all',label:'All'},
			{value:'msil_gate_in',label:'MSIL Gate In'},
			{value:'msil_gate_out',label:'MSIL Gate Out'},
			{value:'icd_arrival_date',label:'ICD Arrival Date'},
			{value:'port_entry_date',label:'Port Entry On'},
			{value:'pol_atd',label:'Port Out On'}
			
		];      
		
        
        return items;
	}
	
	
	handlerStartDateTime = (event, currentDate, selectedDate) => {
    	var d = new Date(event._d);
    	
    	var startdate = d.getFullYear()+"-"+(d.getMonth() +1)+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate());
    	
    	this.setState({
    		startDate:startdate
    	});
    	//let value = event.target.value;
        //this.setState({'startDate':value});
    }

    handlerEndDateTime  = (event) => {
    	var d = new Date(event._d);
    	
        var edate = d.getFullYear()+"-"+(d.getMonth() +1)+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate())
        this.setState({
    		endDate:edate
    	});
	}

	onClickGetData = (event) =>{
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pageTitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventGridAction,
				"label": "Filters",
			}
			googleAnalytics.logEvent(eventOptions);
		}
		var eror=0;
		if(this.state.criteria != null && this.state.criteria != "")
		{
			// this.setState({
			// 	errStyCriteria:'errorStyles',
			// 	show: true, 
			// 	basicType:'danger', 
			// 	basicTitle:"Criteria should not be null",
			// });
			// eror=1;
			//var criteria = {value:"all", label:"All"}
			var criteria = this.state.criteria
			if(this.state.startDate == '')
			{
				this.setState({
					errStyStartDate:'errorStyles',
					show: true, 
					basicType:'danger', 
					basicTitle:"From Date should not be null",
				});
				
				eror=1;
			}
			else{
				this.setState({
					errStyStartDate:''
				});
			}

			if(this.state.endDate == '')
			{
				this.setState({
					errStyEndDate:'errorStyles',
					show: true, 
					basicType:'danger', 
					basicTitle:"To Date should not be null",
				});
				eror=1;
				
			}
			else{
				this.setState({
					errStyEndDate:''
				});
			}
		}
		// else{
		// 	this.setState({
		// 		errStyCriteria:''
		// 	});
		// 	var criteria = this.state.criteria
		// }

		if(this.state.pod == null || this.state.pod == "")
		{
			// this.setState({
			// 	errStyPod:'errorStyles',
			// 	show: true, 
			// 	basicType:'danger', 
			// 	basicTitle:"POD should not be null",
			// });
			// eror=1;
			var pod = {value:"all", label:"All"}
		}
		else{
			this.setState({
				errStyPod:''
			});
			var pod = this.state.pod
		}

		if(this.state.pol == null || this.state.pol == "")
		{
			// this.setState({
			// 	errStyPol:'errorStyles',
			// 	show: true, 
			// 	basicType:'danger', 
			// 	basicTitle:"POL should not be null",
			// });
			// eror=1;
			var pol = {value:"all", label:"All"}
		}
		else{
			this.setState({
				errStyPol:''
			});
			var pol = this.state.pol
		}
		// if(this.state.startDate == '')
		// {
		// 	this.setState({
		// 		errStyStartDate:'errorStyles',
		// 		show: true, 
		// 		basicType:'danger', 
		// 		basicTitle:"From Date should not be null",
		// 	});
			
		// 	eror=1;
		// }
		// else{
		// 	this.setState({
		// 		errStyStartDate:''
		// 	});
		// }

		// if(this.state.endDate == '')
		// {
		// 	this.setState({
		// 		errStyEndDate:'errorStyles',
		// 		show: true, 
		// 		basicType:'danger', 
		// 		basicTitle:"To Date should not be null",
		// 	});
		// 	eror=1;
			
		// }
		// else{
		// 	this.setState({
		// 		errStyEndDate:''
		// 	});
		// }

		if(eror == 0)
		{
			var fdata ={
				pod:pod,
				pol:pol,
				criteria:criteria,
				startDate:this.state.startDate,
				endDate:this.state.endDate,
				page:"filter"
	
			}
			console.log(fdata);
			redirectURL.post("/exports/filterconsignments",fdata)
			.then((response) =>{
				console.log("Response ", response.data)
				var records = response.data;
				records.map(rec => {
					if (rec.icd_source) {
						rec.icd_source = rec.icd_source.toUpperCase();
					}  
					if (rec.status) {
						rec.statusText = this.getStatusText(rec.status);
						//console.log("IN  rec.statusText = ",rec.statusText);
					}  
				})
				console.log("IN EXPORTS , records = ", records, records.length);
				this.setState({
					rowData:records,
					allRowData:records,
				});

				// calculate counters
				let totalConsignmentsCount  = 0;

				let inTransitToMsilData  = null;
				let inTransitToMsilCount  = 0;

				let inTransitToIcdData  = null;
				let inTransitToIcdCount  = 0;

				let insideIcdData  = null;
				let insideIcdCount  = 0;

				let inTransitToPortData  = null;
				let inTransitToPortCount  = 0;

				let insidePortData  = null;
				let insidePortCount  = 0;

				let highSeasData  = null;
				let highSeasCount  = 0;

				let deliveredData  = null;
				let deliveredCount  = 0;

				totalConsignmentsCount = (records) ? records.length : 0;

				inTransitToMsilData = records.filter(rec => rec.status == 1);
				inTransitToMsilCount = (inTransitToMsilData) ? inTransitToMsilData.length : 0;

				inTransitToIcdData = records.filter(rec => rec.status == 3);
				inTransitToIcdCount = (inTransitToIcdData) ? inTransitToIcdData.length : 0;

				insideIcdData = records.filter(rec => rec.status == 4);
				insideIcdCount = (insideIcdData) ? insideIcdData.length : 0;

				inTransitToPortData = records.filter(rec => rec.status == 5);
				inTransitToPortCount = (inTransitToPortData) ? inTransitToPortData.length : 0;

				insidePortData = records.filter(rec => rec.status == 6);
				insidePortCount = (insidePortData) ? insidePortData.length : 0;

				highSeasData = records.filter(rec => rec.status == 7);
				highSeasCount = (highSeasData) ? highSeasData.length : 0;

				deliveredData = records.filter(rec => rec.status == 8);
				deliveredCount = (deliveredData) ? deliveredData.length : 0;

				//console.log("inTransitToMsilData = ", inTransitToMsilData, inTransitToMsilCount);

				this.setState({
					totalConsignmentsCount: totalConsignmentsCount,

					inTransitToMsilData: inTransitToMsilData,
					inTransitToMsilCount: inTransitToMsilCount,

					inTransitToIcdData: inTransitToIcdData,
					inTransitToIcdCount: inTransitToIcdCount,
		
					insideIcdData: insideIcdData,
					insideIcdCount: insideIcdCount,
		
					inTransitToPortData: inTransitToPortData,
					inTransitToPortCount: inTransitToPortCount,
		
					insidePortData: insidePortData,
					insidePortCount: insidePortCount,

					highSeasData: highSeasData,
					highSeasCount: highSeasCount,

					deliveredData: deliveredData,
					deliveredCount: deliveredCount,


				});
			})
			.catch(function(e){
				console.log("Error ",e)
			})
		}
		else{
			this.setState({
				show: true, 
				basicType:'danger', 
				basicTitle:"Fields are mandatory",
			})
		}
	}


    
    onShowConsignmentExportsEventsClick = async (params) => {
		if (googleAnalytics.page.enableGA) {
			let eventLabel = null;
			if (params) {
				let columnFieldName = (params.colDef) ? params.colDef.field : null;
				//console.log("columnFieldName = ", columnFieldName);
				eventLabel = googleAnalytics.page.colDef.exportsConsignments[columnFieldName];
				//console.log("eventLabel = ", eventLabel);
			}
			
			let eventOptions = {
				"category": this.state.pageTitle,
				"action": this.state.eventGridAction,
				"label": eventLabel,
			}
			googleAnalytics.logEvent(eventOptions);
		}


		if(params != 0)
		{
			var eventsData=[];
			// await redirectURL.post('trackBlDeepSea/getcontainertrackingdetails', {
            //     container: params.data.container_no,
            //     sealine: params.data.shipping_line_code,
            //     apiKey: "O1TX-DPHE-WYN6-53MI"
            // })
			// .then(async (response) =>{
			// 	console.log("Step 11 ",response.data)
				
				
			// 	eventsData = await parseEventsData(response.data);
			// 	//params.successCallback(eventsData);
					
			// 	console.log("Step 12 ",response.data)
				
			// });

			//console.log("Step 3 GOING TO SET STATE");
			
			await this.setState({
				//detailCellRenderer: "<div>Test</div>",
				detailCellRendererParams:{
					detailGridOptions: {
						columnDefs: [							
							{ headerName: "Event",field: "description", filter:true,
								cellClass:function(params){
									//console.log("In ", params)
									if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
									{
										return 'green';
									}
									else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
									{
										return 'green';
									}
									else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
									{
										return '';
									}
									else{
										return '';
									}
								},resizable: true
							},
							
							{ headerName: "Place",field: "pod", filter:true,
								cellClass:function(params){
									if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
									{
										return 'green';
									}
									else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
									{
										return 'green';
									}
									else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
									{
										return '';
									}
									else{
										return '';
									}
								},
								valueGetter:function(params){
									//	return getDDMMYYYY(params.data.initial_event_date);
									//(params.data.initial_event_date) 
									return (params.data.pod) ? params.data.pod.toUpperCase() : "";
								},resizable: true
							 },	
							{ 
								headerName: "Initial Estimated Date", field: "initial_event_date", filter:true ,
								cellClass:function(params){
									if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
									{
										return 'green';
									}
									else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
									{
										return 'green';
									}
									else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
									{
										return '';
									}
									else{
										return '';
									}
								},
								valueGetter:function(params){
									return getDDMMYYYY(params.data.initial_event_date);

									//return (params.data.initial_event_date) ?
									//moment.parseZone(params.data.initial_event_date.substring(0,10)).format('DD-MM-YYYY') : "";
								},resizable: true,
								
							},
							{ 
								headerName: "Previous Revised Date", field: "previous_event_date", filter:true ,
								cellClass:function(params){
									if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
									{
										return 'green';
									}
									else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
									{
										return 'green';
									}
									else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
									{
										return '';
									}
									else{
										return '';
									}
								},
								valueGetter:function(params){
									return getDDMMYYYY(params.data.previous_event_date);
								},resizable: true
							},						
							{ 
								headerName: "Actual Event Date", field: "actual_event_date", filter:true ,
								cellClass:function(params){
									if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
									{
										return 'green';
									}
									else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
									{
										return 'green';
									}
									else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
									{
										return '';
									}
									else{
										return '';
									}
								},
								valueGetter:function(params){
									return getDDMMYYYY(params.data.actual_event_date);
								},resizable: true,
								//comparator: dateComparator,
								//sort: "asc"
							}
							// { 
							// 	headerName: "Trip Stage", field: "trip_stage", filter:true ,
							// 	cellClass:function(params){
							// 		if(params.data.event_completed == 1 && params.data.leg_delayed == 0)
							// 		{
							// 			return 'green';
							// 		}
							// 		else if(params.data.event_completed == 1 && params.data.leg_delayed == 1)
							// 		{
							// 			return 'green';
							// 		}
							// 		else if(params.data.event_completed == 0 && params.data.leg_delayed == 1)
							// 		{
							// 			return '';
							// 		}
							// 		else{
							// 			return '';
							// 		}
							// 	},resizable: true,
							// 	valueGetter:function(params){
							// 		if(params.data.trip_stage == 1)
							// 		{
							// 			return 'High Seas';
							// 		}

							// 		if(params.data.trip_stage == 2)
							// 		{
							// 			return 'Port In';
							// 		}

							// 		if(params.data.trip_stage == 3)
							// 		{
							// 			return 'Port Out';
							// 		}

							// 		if(params.data.trip_stage == 4)
							// 		{
							// 			return 'ICD In';
							// 		}

							// 		if(params.data.trip_stage == 5)
							// 		{
							// 			return 'ICD Out';
							// 		}
							// 	}
							// }
							
						],
										
					},
					getDetailRowData: async function(params) {
						console.log("Step 4 eventsData =",eventsData);
						//console.log("Step 5 params = ",params);
						redirectURL.post('/trackBlDeepSea/exports', {
							container: params.data.container_no,
							sealine: params.data.shipping_line_code,
							apiKey: "O1TX-DPHE-WYN6-53MI"
						})
						.then(async (response) =>{
							console.log("Event Step 1 ",response.data)
							//eventsData = await parseEventsData(response.data);
							var nonempty = [];
							var emptyrows = [];
							response.data.map((item) => {
								if(item.hasOwnProperty("actual_event_date"))
								{
									nonempty.push(item)
								}
								else{
									emptyrows.push(item);
								}
							})
							nonempty.sort(function(a, b) {
								var c = new Date(a.actual_event_date);
								var d = new Date(b.actual_event_date);
								return c-d;
							});
							var records = nonempty.concat(emptyrows);
							//console.log("Records ", records);
							params.successCallback(records);
						});
					},

					
					masterDetail: true,
				}
			});
			//console.log("H ", params.column.colDef.field)
			//console.log(params.node.expanded);
			if(params.column.colDef.field == 'sea_transit_delay')
			// || params.column.colId == 'port_delay' || params.column.colId == 'rail_transit_delay' || params.column.colId == 'icd_delay' || params.column.colId == '_id' || params.column.colId == 'msil_transit_delay')
			{
				//console.log("detailCellRendererParams 1111 = ", this.state.detailCellRendererParams, params.column.colId);
				params.node.setExpanded(!params.node.expanded);
				//console.log("params.node.expanded =", params.node.expanded);
			}
			else{
				//console.log("detailCellRendererParams 2222 = ", this.state.detailCellRendererParams, params.column.colId);
				params.node.setExpanded(false);
			}
			//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);
			
		} 
		
	}


	onClickForceCloseConsignment(params){
		

		this.setState({
			open:true,
			forcedata:params.data

		});
	}

	onOpenModal = () => {
		this.setState({ open: true });
	 };
	
	 onCloseModal = () => {
	   this.setState({ open: false });
	 };

	 onCloseCriticalModal = () => {
		this.setState({ opencritical: false });
	  };
 
	 changeHandler(event){
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]:value
        });
	}
	
    handlerCriticalMSILDateTime = (event, currentDate, selectedDate) => {
    	var d = new Date(event._d);
    	
    	//var startdate = d.getFullYear()+"-"+(d.getMonth() +1)+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate());
    	var startdate = moment(d).format("YYYY-MM-DD HH:mm:ss");
		var startdateseconds = moment(d).format("x");
		//console.log("startdate ", startdate);
		//console.log("startdateseconds ", startdateseconds);
    	this.setState({
    		critical_deliver_date:startdate
		});
		
	}
    handlerForceCloseDate = (event, currentDate, selectedDate) => {
    	var d = new Date(event._d);
    	
    	//var startdate = d.getFullYear()+"-"+(d.getMonth() +1)+"-"+(d.getDate()<10?"0"+d.getDate():d.getDate());
    	var startdate = moment(d).format("YYYY-MM-DD HH:mm:ss");
		var startdateseconds = moment(d).format("x");
		//console.log("startdate ", startdate);
		//console.log("startdateseconds ", startdateseconds);
    	this.setState({
    		pod_ata:startdate
		});
		
	}
	formHandler(event){
		event.preventDefault();
		var forcedata = this.state.forcedata;
		var fdata = {
			container_no:forcedata.container_no,
			pod_ata:this.state.pod_ata,
			forceclose_remarks:this.state.forceclose_remarks,
			userId : localStorage.getItem('userid'),
			forcecloseflag:1

		}

		//console.log("fdata ",fdata)
		if(fdata.forceclose_remarks.replace(/\s/g,"").length)
		{
			redirectURL.post("exports/storeForceCloseData", fdata)
			.then((response) => {
				this.setState({
					show: true,
					basicTitle:"Success",
					basicType:"success",
					pod_ata:'',
					forceclose_remarks:'',
					open:false,
					// overly:"show-n",
				});
			})
			.catch(function(e){
				console.log("Error ",e)
			});
		}
		else
		{
			this.setState({
				show: true,
				basicTitle:"Remarks Cant be Empty",
				basicType:"warning",
			});
		}
		

		//console.log("Form data is ", fdata)
	}
	onClickCriticalConsignment(params){
		console.log("Critical Closed ",params.data)
		this.setState({
			opencritical:true,
			criticalrowdata:params.data
		});
	}
	formCriticalHandler(event){
		event.preventDefault();
		var forcedata = this.state.criticalrowdata;
		var fdata = {
			container_no:forcedata.container_no,
			critical_deliver_date:this.state.critical_deliver_date,
			userId : localStorage.getItem('userid'),
			
		}
		//console.log("fdata ",fdata)
		redirectURL.post("exports/storeCriticalCloseData", fdata)
		.then((response) => {
			this.setState({
				show: true,
				basicTitle:"Success",
				basicType:"success",
				critical_deliver_date:'',
				opencritical:false
			});
		})
		.catch(function(e){
			console.log("Error ",e)
		});

		//console.log("Form data is ", fdata)
	}

	onClickSaveGridState(){
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pagetitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventGridAction,
				"label": "Save Grid Layout",
			}
			googleAnalytics.logEvent(eventOptions);
		}
		window.colState = this.gridColumnApi.getColumnState();
		window.groupState = this.gridColumnApi.getColumnGroupState();
		window.sortState = this.gridApi.getSortModel();
		window.filterState = this.gridApi.getFilterModel();
		
		let screenpage = '';

		if(this.props.match.path == "/exports/consignments")
		{
			screenpage='container exports';
		}
		else if(this.props.match.path == "/exports/adaniconsignments")
		{
			screenpage='container exports adani';
		}

		let reqparams = {
			gridcolumns:window.colState,
			gridgroup:window.groupState,
			gridcolsort:window.sortState,
			gridcolfilter:window.filterState,
			userId:localStorage.getItem("userid"),
			screenurl:window.location.pathname,
			screentitle:screenpage
		}
		//console.log("reqparams ", reqparams)
		redirectURL.post("/consignments/saveGridStates", reqparams)
		.then((response) => {
			//console.log("State response ",response.data)
			this.setState({
				show:true,
				basicTitle:"Successfully saved grid layout",
				basicType:"success",
				screenurl:window.location.pathname,
				screentitle:screenpage
			})
		})
		.catch(function(e){
			console.log("Error ", e)
		})
	}

	restoreGridStates()
	{
		try{


			if(this.state.usergridstate.length > 0)
			{
				var windowstates = this.state.usergridstate;
				this.gridColumnApi.setColumnState(windowstates[0].gridcolumns);
				this.gridColumnApi.setColumnGroupState(windowstates[0].gridgroup);
				this.gridApi.setSortModel(windowstates[0].gridcolsort);
				this.gridApi.setFilterModel(windowstates[0].gridcolfilter);
			
			}
		}
		catch(e){}
	}

	resetState = () => {
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pagetitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventGridAction,
				"label": "Reset Grid Layout",
			}
			googleAnalytics.logEvent(eventOptions);
		}
		this.gridColumnApi.resetColumnState();
		this.gridColumnApi.resetColumnGroupState();
		this.gridApi.setSortModel(null);
		this.gridApi.setFilterModel(null);
		//console.log('column state reset');
		var reqparams = {
			userId:localStorage.getItem("userid"),
			screenurl:window.location.pathname,
			screentitle:this.state.screenpage
		}

		redirectURL.post("/consignments/removeUserGridState", reqparams)
		.then((response) => {
			this.setState({
				show:true,
				basicTitle:"Successfully reset default grid layout",
				basicType:"success"
			})
		})

	};
	render(){
		const modalStyles  = {
			width:'500px !important',
			}
		const { open } = this.state;
		const { opencritical } = this.state;

		var userroles = localStorage.getItem('roles')
		let hideppc=(userroles.indexOf("sc_exports") >= 0) ? true : false;
		
		if(this.props.match.path == "/exports/adaniconsignments")
		{
			var hideAdani = true;
		}
		else
		{
			var hideAdani = false;
		}
		const columnwithDefs = [
			
		//	{
				// headerName: "",
				// headerClass:["cellstylegrid","cellTopHeader"],			
				//children: [
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "status",
						width: 40,
						pinned: 'left',
						
						cellRendererSelector:function(params){
							var map_available = 0

							if(params.data.hasOwnProperty('status'))
							{
								if (params.data.status >= 5)
								{
									map_available = 1
									//return { component: 'consignmentActions'}
								}
							}
							if(params.data.hasOwnProperty('icd_gate_out'))
							{
								map_available =1
							}

							//else{
								//return { component: 'consignmentNoActions'}
							//}
							if (map_available == 1)
							{
								return { component: 'consignmentActions'}
							}
							else{
								return { component: 'consignmentNoActions'}
							}

						},
						filter: false,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
						
						//cellClass: function(params) { return 'cellStyleGrid'; }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "msil_transit_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
							return { component: 'exportsIcdToMsilAction'};
						},
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "msil_to_icd_transit_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
							return { component: 'exportsMsilToIcdAction'};
						},
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "icd_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
							return { component: 'exportsInIcdAction'};
						},
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "rail_transit_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
							return { component: 'exportsIcdToPortAction'};
						},
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "port_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
							return { component: 'exportsPortAction'};
						},
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "",
						//headerClass:"cellstylegrid",
						field: "sea_transit_delay",
						width: 40,
						pinned: 'left',
						cellRendererSelector:function(params){
						
							return { component: 'exportsHighSeasAction'};
							
						},
						
						filter: true,resizable: true,
						// cellStyle:function(params){
						// 	return {background:"rgb(241, 251, 255)",color:"#333"}
						// }
					},
					{
						headerName: "Container No",
						//headerClass:"cellstylegrid",
						field: "container_no",
						width: 120,
						pinned: 'left',
						editable:false,
						filter: "agSetColumnFilter",resizable: true,
						//cellClass:'cellstylegrid'
					},
					{
						headerName: "Status",
						//headerClass:"cellstylegrid",
						field: "statusText",
						width: 120,
						pinned: 'left',
						editable:false,
						filter: "agSetColumnFilter",resizable: true,
						//cellClass:'cellstylegrid'
					},

					{
						headerName: "ETA",
						field: "expected_etd",
						width: 120,
						pinned: 'left',
						editable:false,
						filter: "agSetColumnFilter",resizable: true,
						//cellClass:'cellstylegrid'
						valueGetter:function(params){
							//console.log("params.data.icd_gate_out ", params.data.icd_gate_out)
							if(params.data.expected_etd != '' && typeof params.data.expected_etd != 'undefined')
							{
								var s = params.data.expected_etd;
								// var sp = s.split(" ");
								// //console.log(sp)
								// var d = sp[0].split("-")
								// var icd_dt = d[2]+"-"+d[1]+"-"+d[0]+" "+sp[1]
								return getHyphenDDMMMYYYY(s);
							}
							else{
								return '';
							}
						},
						//filter: "agDateColumnFilter",
						comparator: dateComparator1,
						// filterParams: {
						// 	browserDatePicker: true,
						// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
						// 	// provide comparator function
						// 	comparator: function(filteredDate,cellValue,secondDate) {
						// 		cellValue = cellValue.replace(/\//g,"-")
						// 		if(cellValue != "" && cellValue != " "){
						// 			cellValue = cellValue.split(" ")[0].split("-");
						// 			cellValue =getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
						// 			var cellDate = new Date(cellValue);
						// 			if(filteredDate.getMonth() < 10){
						// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
						// 			}
						// 			else{
						// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
						// 			}
						// 			var filteredDate = new Date(filterValue);
						// 			cellDate = cellDate.getTime();
						// 			filteredDate = filteredDate.getTime();
						// 			// console.log(cellDate,filteredDate);
						// 			// console.log(cellValue,filterValue);
						// 			if(cellDate === filteredDate)
						// 			{
						// 				return 0;
						// 			}
						// 			if(cellDate < filteredDate){
						// 				return -1;
						// 			}
						// 			if(cellDate > filteredDate)
						// 			{
						// 				return 1;
						// 			}
						// 		}
						// 	}
						// }
					},

					{
						headerName: "Revised ETA",
						//headerClass:"cellstylegrid",
						field: "revised_etd",
						width: 120,
						pinned: 'left',
						editable:false,
						filter: "agSetColumnFilter",
						resizable: true,
						//cellClass:'cellstylegrid'
						valueGetter:function(params){
							//console.log("params.data.icd_gate_out ", params.data.icd_gate_out)
							if(params.data.revised_etd != '' && typeof params.data.revised_etd != 'undefined')
							{
								var s = params.data.revised_etd;
								// var sp = s.split(" ");
								// //console.log(sp)
								// var d = sp[0].split("-")
								// var icd_dt = d[2]+"-"+d[1]+"-"+d[0]+" "+sp[1]
								return getHyphenDDMMMYYYY(s);
							}
							else{
								return '';
							}
						},
						//filter: "agDateColumnFilter",
						comparator: dateComparator1,
						// filterParams: {
						// 	browserDatePicker: true,
						// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
						// 	// provide comparator function
						// 	comparator: function(filteredDate,cellValue,secondDate) {
						// 		cellValue = cellValue.replace(/\//g,"-")
						// 		if(cellValue != "" && cellValue != " "){
						// 			cellValue = cellValue.split(" ")[0].split("-");
						// 			cellValue =getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
						// 			var cellDate = new Date(cellValue);
						// 			if(filteredDate.getMonth() < 10){
						// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
						// 			}
						// 			else{
						// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
						// 			}
						// 			var filteredDate = new Date(filterValue);
						// 			cellDate = cellDate.getTime();
						// 			filteredDate = filteredDate.getTime();
						// 			// console.log(cellDate,filteredDate);
						// 			// console.log(cellValue,filterValue);
						// 			if(cellDate === filteredDate)
						// 			{
						// 				return 0;
						// 			}
						// 			if(cellDate < filteredDate){
						// 				return -1;
						// 			}
						// 			if(cellDate > filteredDate)
						// 			{
						// 				return 1;
						// 			}
						// 		}
						// 	}
						// },
						cellClass:function(params){
							let hourDifference = 0;
							if (params.data.revised_etd && params.data.expected_etd) {
								var revise = params.data.revised_etd;
								var rev = revise.split("T");
								var revisedDate = rev[0];

								var expectd = params.data.expected_etd;
								var exdate = expectd.split("T");
								var expectedDate = exdate[0];

								let revisedDateOnlyMoment  = moment.parseZone(revisedDate).format("x");
								let expectedDateOnlyMoment  = moment.parseZone(expectedDate).format("x");
								//hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours'); 
								// console.log("revisedDateOnlyMoment= ", revisedDateOnlyMoment); 
								// console.log("expectedDateOnlyMoment= ", expectedDateOnlyMoment);
								if(revisedDateOnlyMoment > expectedDateOnlyMoment)
								{
									hourDifference = 1
								}
								if(revisedDateOnlyMoment < expectedDateOnlyMoment)
								{
									hourDifference = -1
								}
								if(revisedDateOnlyMoment == expectedDateOnlyMoment)
								{
									hourDifference = 0
								}
							} else {
								//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
							}
	
							if(hourDifference == 1)
							{
								return 'bgColorDangerMedium'
							}
	
							if(hourDifference < 0)
							{
								return 'bgColorSuccessMedium'
							}
							else{
								return ''
							}
						}
					},
					{
						headerName: "<i class='icofont icofont-truck'></i> ICD TO MSIL",
						headerClass:["cellstylegridB","cellTopHeader"],			
						children: [
							{ 
								headerName: "Booking Id",
								//headerClass:"cellstylegrid",
								field: "booking_id",
								width: 120,
								editable:false,
								filter: "cellstylegridB",
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								resizable: true,
								
							},
							{
								headerName: "Shipping Line",
								field: "shipping_line",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",resizable: true,
								
							},
							{
								headerName: "Plant Name",
								field: "plant_name",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",resizable: true,
								
							},
							{
								headerName: "ICD Name (source)",
								//headerClass:"cellstylegrid",
								field: "icd_source",
								width: 120,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",
								resizable: true,
								
							},
							{
								headerName: "Container Size",
								//headerClass:"cellstylegrid",
								field: "container_size",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",resizable: true,
								
							},
							{
								headerName: "Cargo Type",
								//headerClass:"cellstylegrid",
								field: "cargo_type",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",resizable: true,
								
							},
							{
								headerName: "ICD Gate Out",
								field: "icd_gate_out",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",
								resizable: true,
								valueGetter:function(params){
									//console.log("params.data.icd_gate_out ", params.data.icd_gate_out)
									if(params.data.icd_gate_out != '' && typeof params.data.icd_gate_out != 'undefined')
									{
										var s = params.data.icd_gate_out;
										var sp = s.split(" ");
										//console.log(sp)
										var d = sp[0].split("-")
										var icd_dt = d[2]+"-"+d[1]+"-"+d[0]+" "+sp[1]
										return getHyphenDDMMMYYYYHHMM(icd_dt);
									}
									else{
										return '';
									}
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue =getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// }
							},
							{
								headerName: "Trailer No",
								field: "trailer_no",
								width: 150,
								editable:false,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								filter: "agSetColumnFilter",resizable: true,
								
							},
							{
								headerName: "Last GPS Time",
								field: "truck",
								width: 150,
								editable:false,
								filter: "agSetColumnFilter",
								resizable: true,
								headerClass : "cellstylegridB",
								cellClass : "cellstylegridB",
								valueGetter:function(params){
									if(typeof params.data.truck != 'undefined')
									{
										if(typeof params.data.truck[0] != 'undefined')
										{
											return getHyphenDDMMMYYYYHHMM(params.data.truck[0].timestamp);
										}
										else{
											return "";
										}
									}
									else
									{
										return "";
									}
								}
							}
							
						]
					},
					// {
					// 	headerName: "Empty Container to MSIL",
					// 	field: "empty_container_to_msil",
					// 	width: 150,
					// 	editable:false,
					// 	filter: "agSetColumnFilter",resizable: true,
						
					// },
					{
						headerName: "<i class='icofont icofont-truck'></i> MSIL TO ICD",
						headerClass:["cellstylegrid","cellTopHeader"],			
						children: [

							{
								headerName: "Invoice Date",
								field: "invoice_date",
								width: 150,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								editable:false,
								filter: "agSetColumnFilter",resizable: true,
								hide: hideAdani
							},
							{
								headerName: "MSIL Gate In",
								field: "msil_gate_in",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								valueGetter:function(params){
									return getHyphenDDMMMYYYY(params.data.msil_gate_in);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								hide: hideAdani
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue =getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							{
								headerName: "GPS MSIL Gate In",
								field: "gps_msil_gate_in",
								width: 150,
								editable:false,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								resizable: true,
								valueGetter:function(params){
									return getHyphenDDMMMYYYYHHMM(params.data.gps_msil_gate_in);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								hide: hideAdani
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue =getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							{
								headerName: "MSIL Gate Out",
								field: "msil_gate_out",
								width: 150,
								editable:false,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								// filter: "agSetColumnFilter",
								resizable: true,
								valueGetter:function(params){
									return getHyphenDDMMMYYYY(params.data.msil_gate_out);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								hide: hideAdani
								// filterParams: {
								// browserDatePicker: true,
								// filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// // provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },

							},
							{
								headerName: "GPS MSIL Gate Out",
								field: "gps_msil_gate_out",
								width: 150,
								editable:false,
								// filter: "agSetColumnFilter",
								resizable: true,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								valueGetter:function(params){
									return getHyphenDDMMMYYYYHHMM(params.data.gps_msil_gate_out);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								hide: hideAdani
								// filterParams: {
								// browserDatePicker: true,
								// filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// // provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
								

							},
							{
								headerName: "ICD Arrival Date",
								field: "icd_arrival_date",
								width: 150,
								editable:false,
								headerClass : "cellstylegrid",
								// cellClass : "green",
								filter: "agSetColumnFilter",
								resizable: true,
								valueGetter:function(params){

									if(params.data.icd_arrival_date != '' && typeof params.data.icd_arrival_date != 'undefined')
									{
										return getHyphenDDMMMYYYY(params.data.icd_arrival_date);
									}
									else{
										if(params.data.gps_icd_arrival_date != '' && typeof params.data.gps_icd_arrival_date != "undefined" )
										{
											return getHyphenDDMMMYYYY(params.data.gps_icd_arrival_date);
										}
										else{
											return "";
										}
									}
									
								},
								cellClass:function(params){
									let hourDifference = 0;

									var expectd="";
									if(params.data.icd_arrival_date != '' && typeof params.data.icd_arrival_date != 'undefined')
									{
										var expectd = params.data.icd_arrival_date;
									}
									else{
										if(params.data.gps_icd_arrival_date != '' && typeof params.data.gps_icd_arrival_date != "undefined" )
										{
											var expectd = params.data.gps_icd_arrival_date;
										}
										else{
											var expectd = "";
										}
									}

									if (params.data.expected_icd_arraival_date && expectd != "") {
										
										var revise = params.data.expected_icd_arraival_date;
										var rev = revise.split("T");
										var revisedDate = rev[0];
										//console.log("revise ", revise)

										var expectd = expectd;
										var exdate = expectd.split("T");
										var expectedDate = exdate[0];
										
										let revisedDateOnlyMoment  = moment.parseZone(revisedDate).format("x");
										let expectedDateOnlyMoment  = moment.parseZone(expectedDate).format("x");
										//hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours'); 
										console.log("revisedDateOnlyMoment= ", revisedDateOnlyMoment); 
										console.log("expectedDateOnlyMoment= ", expectedDateOnlyMoment);
										if(revisedDateOnlyMoment > expectedDateOnlyMoment)
										{
											hourDifference = 1
										}
										if(revisedDateOnlyMoment < expectedDateOnlyMoment)
										{
											hourDifference = -1
										}
										if(revisedDateOnlyMoment == expectedDateOnlyMoment)
										{
											hourDifference = 0
										}
									} else {
										//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
									}
			
									if(hourDifference == 1)
									{
										return 'cellstylegrid'
									}
			
									if(hourDifference < 0)
									{
										return 'cellstylegrid'
									}
									else{
										return 'cellstylegrid'
									}
								}
								
							},
							
							// {
							// 	headerName: "GPS ICD Arrival Date",
							// 	field: "gps_icd_arrival_date",
							// 	width: 150,
							// 	editable:false,
							// 	headerClass : "cellstylegrid",
							// 	// cellClass : "green",
							// 	filter: "agSetColumnFilter",
							// 	resizable: true,
							// 	valueGetter:function(params){
							// 		return getHyphenDDMMMYYYY(params.data.gps_icd_arrival_date);
							// 	},
							// 	cellClass:function(params){
							// 		let hourDifference = 0;
							// 		if (params.data.expected_icd_arraival_date && params.data.gps_icd_arrival_date) {
										
							// 			var revise = params.data.expected_icd_arraival_date;
							// 			var rev = revise.split("T");
							// 			var revisedDate = rev[0];
							// 			//console.log("revise ", revise)

							// 			var expectd = params.data.gps_icd_arrival_date;
							// 			var exdate = expectd.split("T");
							// 			var expectedDate = exdate[0];
										
							// 			let revisedDateOnlyMoment  = moment.parseZone(revisedDate).format("x");
							// 			let expectedDateOnlyMoment  = moment.parseZone(expectedDate).format("x");
							// 			//hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours'); 
							// 			console.log("revisedDateOnlyMoment= ", revisedDateOnlyMoment); 
							// 			console.log("expectedDateOnlyMoment= ", expectedDateOnlyMoment);
							// 			if(revisedDateOnlyMoment > expectedDateOnlyMoment)
							// 			{
							// 				hourDifference = 1
							// 			}
							// 			if(revisedDateOnlyMoment < expectedDateOnlyMoment)
							// 			{
							// 				hourDifference = -1
							// 			}
							// 			if(revisedDateOnlyMoment == expectedDateOnlyMoment)
							// 			{
							// 				hourDifference = 0
							// 			}
							// 		} else {
							// 			//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
							// 		}
			
							// 		if(hourDifference == 1)
							// 		{
							// 			return 'cellstylegrid'
							// 		}
			
							// 		if(hourDifference < 0)
							// 		{
							// 			return 'cellstylegrid'
							// 		}
							// 		else{
							// 			return 'cellstylegrid'
							// 		}
							// 	}
								
							// },
							{
								headerName: "Customs Cleared On",
								field: "leo_date",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								valueGetter:function(params){
									return getHyphenDDMMMYYYY(params.data.leo_date);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								// filterParams: {
								// browserDatePicker: true,
								// filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							{
								headerName: "Handover Date",
								field: "handover_date",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegrid",
								cellClass : "cellstylegrid",
								valueGetter:function(params){
									return getHyphenDDMMMYYYY(params.data.handover_date);
								},
								//filter: "agDateColumnFilter",
								comparator: dateComparator1,
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = getMonthNumber(cellValue[1]) +"-"+cellValue[0]+"-"+cellValue[2];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = "0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			else{
								// 				var filterValue = (filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()+"-"+filteredDate.toString().split(" ")[3]
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			// console.log(cellValue,filterValue);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// }
							},
						]
					},
					// {
					// 	headerName: "<i class='icofont icofont-truck'></i> Inside ICD",
					// 	headerClass:["cellstylegrid","cellTopHeader"],			
					// 	children: [
							
					// 	]
					// },
					{
						headerName: "<i class='icofont icofont-ship'></i> ICD To Port",
						headerClass:["cellstylegridSk","cellTopHeader"],			
						children: [
							
							{
								headerName: "Train/Truck No",
								field: "line_no",
								width: 150,
								editable:false,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								filter: "agSetColumnFilter",resizable: true,
							},
							{
								headerName: "Rail Out Date",
								field: "railout_date",
								width: 150,
								editable:false,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								filter: "agSetColumnFilter",resizable: true,
								valueGetter:function(params){
									if(typeof params.data.railout_date != 'undefined' && params.data.railout_date != '')
									{
										return getHyphenDDMMMYYYY(params.data.railout_date)
									}
									else{
										return '';
									}
								}
							},
							{
								headerName: "Port of Loading",
								field: "port_of_export",
								width: 150,
								editable:false,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								filter: "agSetColumnFilter",resizable: true,
								valueGetter:function(params){
									if(params.data.searates_pol != '' && typeof params.data.searates_pol != 'undefined')
									{
										return params.data.searates_pol;
									}
									else
									{
										return '';
									}
									
								}
							},
							{
								headerName: "Port Entry On",
								field: "port_entry_date",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								//filter: "agDateColumnFilter",
								comparator: dateComparator,
								valueGetter:function(params){
									if(params.data.port_entry_date != '' && typeof params.data.port_entry_date != 'undefined' && params.data.port_entry_date != null)
									{
										var ped = new Date(params.data.port_entry_date);
										return moment.parseZone(ped).utcOffset("+05:30").format("DD-MMM-YYYY")
									}
									else{
										return '';
									}
									
									/*port_entry_date > expected_port_in  red*/
									/*port_entry_date < expected_port_in  green*/
									/*port_entry_date = expected_port_in  normal*/ 
								},
								// cellClass:function(params){
								// 	let hourDifference = 0;
								// 	if (params.data.port_entry_date && params.data.expected_port_in) {
										
								// 		var revise = params.data.expected_port_in;
								// 		var rev = revise.split("T");
								// 		var revisedDate = rev[0];
								// 		//console.log("revise ", revise)

								// 		var expectd = params.data.port_entry_date;
								// 		var exdate = expectd.split("T");
								// 		var expectedDate = exdate[0];
										

								// 		let revisedDateOnlyMoment  = moment.parseZone(revisedDate).format("x");
								// 		let expectedDateOnlyMoment  = moment.parseZone(expectedDate).format("x");
								// 		//hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours'); 
								// 		// console.log("revisedDateOnlyMoment= ", revisedDateOnlyMoment); 
								// 		// console.log("expectedDateOnlyMoment= ", expectedDateOnlyMoment);
								// 		if(revisedDateOnlyMoment > expectedDateOnlyMoment)
								// 		{
								// 			hourDifference = 1
								// 		}
								// 		if(revisedDateOnlyMoment < expectedDateOnlyMoment)
								// 		{
								// 			hourDifference = -1
								// 		}
								// 		if(revisedDateOnlyMoment == expectedDateOnlyMoment)
								// 		{
								// 			hourDifference = 0
								// 		}
								// 	} else {
								// 		//console.log("ELSE = ", params.data.revised_trip, params.data.expected_trip_end);
								// 	}
			
								// 	if(hourDifference == 1)
								// 	{
								// 		return 'bgColorDangerMedium'
								// 	}
			
								// 	if(hourDifference < 0)
								// 	{
								// 		return 'bgColorSuccessMedium'
								// 	}
								// 	else{
								// 		return ''
								// 	}
								// },
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			else{
								// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							
							{
								headerName: "ETD POL",
								field: "pol_etd",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								//filter: "agDateColumnFilter",
								comparator: dateComparator,
								valueGetter:function(params){
									if(params.data.pol_etd != '' && typeof params.data.pol_etd != 'undefined' && params.data.pol_etd != null)
									{
										//console.log(params.data.container_no);
										//console.log(params.data.pol_atd);
										var s = params.data.pol_etd;
										var sd = s.split(" ");
										var pout = sd[0].split("-")
										var portout = pout[2]+"-"+pout[1]+"-"+pout[0];
										//console.log(portout)
										//var ped = new Date(params.data.pol_atd);
										return moment.parseZone(portout).format("DD-MMM-YYYY")
									}
									else{
										return '';
									}
										
								},
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			else{
								// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							
							{
								headerName: "ATD POL",
								field: "pol_atd",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								//filter: "agDateColumnFilter",
								comparator: dateComparator,
								valueGetter:function(params){
									if(params.data.pol_atd != '' && typeof params.data.pol_atd != 'undefined' && params.data.pol_atd != null)
									{
										//console.log(params.data.container_no);
										//console.log(params.data.pol_atd);
										var s = params.data.pol_atd;
										var sd = s.split(" ");
										var pout = sd[0].split("-")
										var portout = pout[2]+"-"+pout[1]+"-"+pout[0];
										//console.log(portout)
										//var ped = new Date(params.data.pol_atd);
										return moment.parseZone(portout).format("DD-MMM-YYYY")
									}
									else{
										return '';
									}
										
								},
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			else{
								// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							{
								headerName: "ETA POD",
								field: "pod_eta",
								width: 150,
								editable:false,
								resizable: true,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								//filter: "agDateColumnFilter",
								comparator: dateComparator,
								valueGetter:function(params){
									if(params.data.pod_eta != '' && typeof params.data.pod_eta != 'undefined' && params.data.pod_eta != null)
									{
										//console.log(params.data.container_no);
										//console.log(params.data.pol_atd);
										var s = params.data.pod_eta;
										var sd = s.split(" ");
										var pout = sd[0].split("-")
										var portout = pout[2]+"-"+pout[1]+"-"+pout[0];
										//console.log(portout)
										//var ped = new Date(params.data.pol_atd);
										return moment.parseZone(portout).format("DD-MMM-YYYY")
									}
									else{
										return '';
									}
										
								},
								// filterParams: {
								// 	browserDatePicker: true,
								// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
								// 	// provide comparator function
								// 	comparator: function(filteredDate,cellValue,secondDate) {
								// 		cellValue = cellValue.replace(/\//g,"-")
								// 		if(cellValue != "" && cellValue != " "){
								// 			cellValue = cellValue.split(" ")[0].split("-");
								// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
								// 			var cellDate = new Date(cellValue);
								// 			if(filteredDate.getMonth() < 10){
								// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			else{
								// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
								// 			}
								// 			var filteredDate = new Date(filterValue);
								// 			cellDate = cellDate.getTime();
								// 			filteredDate = filteredDate.getTime();
								// 			// console.log(cellDate,filteredDate);
								// 			if(cellDate === filteredDate)
								// 			{
								// 				return 0;
								// 			}
								// 			if(cellDate < filteredDate){
								// 				return -1;
								// 			}
								// 			if(cellDate > filteredDate)
								// 			{
								// 				return 1;
								// 			}
								// 		}
								// 	}
								// },
							},
							{
								headerName: "Delivery Location",
								field: "pod_name",
								width: 150,
								editable:false,
								headerClass : "cellstylegridSk",
								cellClass : "cellstylegridSk",
								filter: "agSetColumnFilter",resizable: true,
							}
						]
					},
					{
						headerName: "SPOC Name",
						field: "spoc_contact_name",
						width: 150,
						editable:false,
						resizable: true,
						filter: "agSetColumnFilter",
					},
					{
						headerName: "SPOC Contact",
						field: "spoc_contact_number",
						width: 150,
						editable:false,
						resizable: true,
						filter: "agSetColumnFilter",
					},
					{
						headerName: "Force Close",
						field: "_id",
						width: 150,
						editable:false,
						hide:hideppc,
						//filter: "agDateColumnFilter",
						resizable: true,
						cellRendererSelector:function(params){
							//console.log("params ", params)
							return { component: 'forceclose'};
							
						},
						
					},
					{
						headerName: "Critical",
						field: "_id",
						width: 150,
						editable:false,
						hide:hideppc,
						filter: false,resizable: true,
						cellRendererSelector:function(params){
							//console.log("params ", params)
							return { component: 'criticalaction'};
							
						},
						
					},
					{
						headerName: "Transhipment",
						field: "_id",
						width: 150,
						editable:false,
						hide:hideppc,
						filter: false,resizable: true,
						valueGetter:function(params){
							if(params.data.is_transshipment == 1)
							{
								return "Yes";
							}
							else
							{
								return "No";
							}
						}
					},
					{
						headerName: "Old Container No",
						field: "old_container_no",
						width: 150,
						editable:false,
						hide:hideppc,
						filter: true,
						resizable: true,
					},
					{
						headerName: "Transhipment Date",
						field: "transhipment_date",
						width: 150,
						editable:false,
						hide:hideppc,
						filter: true,
						resizable: true,
						valueGetter:function(params){
							if(typeof params.data.transhipment_date != 'undefined' && params.data.transhipment_date != '')
							{
								return getHyphenDDMMMYYYY(params.data.transhipment_date)
							}
							else{
								return '';
							}
						}
					},
					{
						headerName: "Transhipment Reason",
						field: "transhipment_reason",
						width: 150,
						editable:false,
						hide:hideppc,
						filter: true,
						resizable: true,
					}
				//]
			//},

		];
		const dStyles={
			width:this.props.width,
			height:'500px',
			marginLeft:this.props.marginLeft,

	}

		return(
			<div className="container-fluid">
				<Breadcrumb parent="Container" title="Exports" />
			<SweetAlert
	            show={this.state.show}
	            type={this.state.basicType}
	            title={this.state.basicTitle}
	            onConfirm={this.closeAlert}
	        >
	        </SweetAlert>
	            {this.state.alert}
				<div className="row col-xl-12 col-lg-12">
					<form method="POST" className="form-theme col-xl-12 col-lg-12 row">
					<div className="form-group col-xl-2 col-lg-2">
						<label>Select POL: </label>
						<Select placeholder={"Select POL"} closeMenuOnSelect={false} value={this.state.pod} isMulti="true" className={"border-radius-0 "+(this.state.errStyPod)} onChange={this.getPodListItems.bind(this)} style={{borderRadius:"0px"}} options={this.selectPodOptionsItems()} />
                                       
					</div>
					<div className="form-group col-xl-2 col-lg-2" style={{borderRight:"1px solid #aaa"}}>
						<label>Select POD: </label>
						<Select placeholder={"Select POD"} closeMenuOnSelect={false} value={this.state.pol} isMulti="true" className={"border-radius-0 "+(this.state.errStyPol)} onChange={this.getPolListItems.bind(this)} style={{borderRadius:"0px"}} options={this.selectPolOptionsItems()} />
                                       
					</div>
					<div className="form-group col-xl-2 col-lg-2">
						<label>Select Criteria: </label>
						<Select placeholder={"Select Criteria"} closeMenuOnSelect={false} value={this.state.criteria} className={"border-radius-0 "+(this.state.errStyCriteria)} onChange={this.getCriteriaListItems.bind(this)} style={{borderRadius:"0px"}} options={this.selectCriteriaOptionsItems()} />
                                       
					</div>
					<div className="col-xl-2 col-lg-2 form-group">
						<label>From Date</label>
						<Datetime className={this.state.errStyStartDate} value={this.state.startDate} disableCloseOnClickOutside={false} closeOnSelect={true} inputProps={{ placeholder: 'From', name: 'startDate', autoComplete:'off', required:true }} dateFormat="YYYY-MM-DD"  name="startDate" onChange={this.handlerStartDateTime.bind(this)} />
					</div>

					<div className="col-xl-2 col-lg-2 form-group">
						<label>To Date</label>
						<Datetime className={this.state.errStyEndDate} value={this.state.endDate} disableCloseOnClickOutside={false} closeOnSelect={true} inputProps={{ placeholder: 'To', name: 'endDate', autoComplete:'off', required:true}} dateFormat="YYYY-MM-DD" onChange={this.handlerEndDateTime.bind(this)} />
					</div>
					
					<div className="form-group col-xl-2 col-lg-2">
						<label>&nbsp;</label><br />
						<button type="button" className="btn btn-success" style={{padding:"5px 10px"}} onClick={this.onClickGetData.bind(this)}>Submit</button>
						<a href="/exports/consignments" className="btn btn-primary" style={{padding:"5px 10px"}}>Reset</a>
					
					</div>
					</form>
				</div>

				<ExportsConsignmentsCounters 
					context={this}
					allRowDatacount={this.state.allRowData.length}
					totalConsignmentsCount={this.state.totalConsignmentsCount}
					//inTransitToMsilCount={this.state.inTransitToMsilCount.length}
					inTransitToMsilCount={this.state.inTransitToMsilCount}
					inTransitToIcdCount={this.state.inTransitToIcdCount}
					insideIcdCount={this.state.insideIcdCount}
					inTransitToPortCount={this.state.inTransitToPortCount}
					insidePortCount={this.state.insidePortCount}
					highSeasCount={this.state.highSeasCount}
					
				 />
            	<div className="row">					
            		<div className="col-xl-12 col-lg-12">
		            	<div className="card">
                            <div className="card-header">
				       			<h5>
				       				<i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>{this.state.pageTitle} </span>
									{/* <span className="float-right f13">
										<i className="icofont icofont-truck-alt f24"></i> - ICD To MSIL &nbsp; &nbsp;
										<i className="icofont icofont-van-alt f25"></i> - MSIL to ICD &nbsp; &nbsp;
										<i className="icofont icofont-ui-home f20"></i> - Inside ICD &nbsp; &nbsp;
										<i className="icofont icofont-train-line f20"></i> - ICD to Port &nbsp; &nbsp;
										<i className="icofont icofont-ship f20"></i> - Inside Port &nbsp; &nbsp;
										<i className="icofont icofont-ship-alt f20"></i> - High Seas &nbsp; &nbsp;
									</span> */}


									<span className="layoutbtns float-right">
										<button className="float-right custom-btn white btn-danger" onClick={this.onClickSaveGridState.bind(this)}>
											<i className="icofont icofont-save"></i> Save Grid Layout
										</button>
										<button className="float-right custom-btn white btn-info" style={{marginRight:"10px"}} onClick={this.resetState.bind(this)}>
											<i className="icofont icofont-refresh"></i> Reset Default Layout
										</button>
									</span>

								</h5>
				   			</div>				   			
		            		<div className="card-body">
								
								 <div id="myGrid" style={{ height: "580px",width: "100%"}}  className="ag-theme-balham">
		          		          <AgGridReact
		          		            modules={this.state.modules}
		          		            columnDefs={columnwithDefs}
		          		            defaultColDef={this.state.defaultColDef}
		          		            rowData={this.state.rowData}
		          		            enableCharts={true}
		          		            enableRangeSelection={true}
		          		            autoGroupColumnDef={this.state.autoGroupColumnDef}
		          		            onGridReady={this.onGridReady}
		          		            onGridState={this.onGridState}
		          		            statusBar={this.state.statusBar}
		          	                sideBar={this.state.sideBar}
									paginationPageSize={this.state.paginationPageSize}
									pagination={true}
									frameworkComponents={this.state.frameworkComponents}
									detailCellRendererParams={this.state.detailCellRendererParams}
									//editType={this.state.editType}
									stopEditingWhenGridLosesFocus={true}
									floatingFilter={false}
									enableCellChangeFlash={true}
									suppressCellFlash={true}
									rowClassRules={this.state.rowClassRules}
									//onCellClicked={this.onRowClicked.bind(this)}
									gridOptions={{
										context: { componentParent: this }
									}}
									masterDetail={true}
									headerHeight={this.state.headerHeight}
									//groupHeaderHeight={this.state.groupHeaderHeight}
		          		          />

									<div className={"dataLoadpage " +(this.state.loadshow)}>
									</div>
									<div className={"dataLoadpageimg " +(this.state.loadshow)}>
										<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
									</div>

		          		        </div>
				   			</div>
				   		</div>	
				   	</div>
				 </div>
				
				
				 {this.state.sliderRouteTranslate != ''?
					 <div className={"slide-r "+(this.state.sliderRouteTranslate)} style={{overflow:"auto"}}>
					 	<div className="slide-r-title">
							<h4>
								Container Routes #{this.state.consignment_code}
								<span className="float-right closebtn" style={{marginRight:"25px"}} onClick={this.onCloseRouteDiv.bind(this)} >X</span>
										
							</h4>
						</div>
						<div className="slide-r-body" style={{position:"relative"}}>
							
							<div className="row col-xl-12 col-lg-12">
								{(this.state.mapinfo != '')?
								<DrawMap mapFor={"exportsconsignment"} tolls={this.state.tolls} mapinfo={this.state.mapinfo} defTransitCoords={this.state.defTransitCoords} />
								
							:""}
								{(this.state.mapinfo != '')?
								<div className="col-xl-12 col-lg-12">
									<div className="crm-numbers pb-0">
										<h3 className="subH">Route Details</h3>
										<div className="col-xl-12 col-lg-12 row">
											<div className="col route-block">
												<label className="sidebar-label">Truck No</label>
												<div>{this.state.truck_no}</div>
											</div>
											<div className="col route-block">
												<label className="sidebar-label">Last Event Date</label>
												<div>{(this.state.mapinfo.route_details.start_time != '')?this.state.mapinfo.route_details.start_time:"NA"}</div>
											</div>
											<div className="col route-block">
												<label className="sidebar-label">Event Description</label>
												<div>{(this.state.mapinfo.route_details.end_time != '')?this.state.mapinfo.route_details.end_time:"NA"}</div>
											</div>
											
											<div className="col route-block">
												<label className="sidebar-label">Last Known Location</label>
												<div>{(this.state.mapinfo.route_details.distance != "")?Math.round(this.state.mapinfo.route_details.distance/1000):"0"} KM </div>
											</div>
											
										</div>
									</div>
								</div>
								:""}
							</div>
						</div>
					</div>
				:""	
				}
				<Modal open={open} onClose={this.onCloseModal} styles={modalStyles} >
	                <div className={""} style={{ overflow: 'hidden',zIndex:'9999',}} >
						<form className="row col-xl-12 col-lg-12 theme-form" method="post" onSubmit={this.formHandler.bind(this)}>
						<h5 className="modeltitle">Force Closure</h5>
						<div className="col-md-12 col-sm-12 col-xl-12 col-lg-12 ">
							<div className="col-md-4 col-sm-4 col-xl-4 col-lg-4 ">
								<div className="form-group">
									<label className="col-form-label">Delivered Date:</label>
									<Datetime 
									//value={this.state.msil_gatein_date} 
									disableCloseOnClickOutside={false} 
									//closeOnSelect={true} 
									inputProps={{ placeholder: 'Delivered Date', name: 'pod_ata', autoComplete:'off' }}
									dateFormat="YYYY-MM-DD"  
									timeFormat="HH:mm:ss"  
									name="pod_ata" 
									onChange={this.handlerForceCloseDate.bind(this)}
									/>
								</div>
							</div>
							
							<div className="col-md-12 col-sm-12 col-xl-12 col-lg-12 ">
								<div className="form-group">
									<label className="col-form-label">Remarks:</label>
									<textarea required id="forceclose_remarks" className="form-control" rows="6" name="forceclose_remarks" value={this.state.forceclose_remarks} onChange={this.changeHandler.bind(this)} placeholder="Enter Remarks"/>
								</div>
							</div>
							<div className="col-md-12 col-sm-12 col-xl-12 col-lg-12 ">
								<div className="form-group">
									<button type="submit" className="btn btn-success" name="submit">Submit</button>						
								</div>
								
							</div>
						</div>
						</form>
					</div>
				</Modal>

				<Modal open={opencritical} onClose={this.onCloseCriticalModal} styles={modalStyles} >
	                <div className={""} style={{zIndex:'9999',}} >
						<form className="row col-xl-12 col-lg-12 theme-form" method="post" onSubmit={this.formCriticalHandler.bind(this)}>
						<h5 className="modeltitle">Critical</h5>
						<div className="col-md-4 col-sm-4 col-xl-4 col-lg-4 ">
							<div className="form-group">
								<label className="col-form-label">Expected Delivery Date:</label>
								<Datetime 
								//value={this.state.msil_gatein_date} 
								disableCloseOnClickOutside={false} 
								//closeOnSelect={true} 
								inputProps={{ placeholder: 'Expected Delivery Date', name: 'critical_deliver_date', autoComplete:'off' }}
								dateFormat="YYYY-MM-DD"  
								timeFormat="HH:mm:ss"  
								name="critical_deliver_date" 
								onChange={this.handlerCriticalMSILDateTime.bind(this)}
								/>
							</div>
						</div>
					
						<div className="col-md-12 col-sm-12 col-xl-12 col-lg-12 ">
							<div className="form-group">
								<button type="submit" className="btn btn-success" name="submit">Submit</button>						
							</div>
							
						</div>
						</form>
					</div>
				</Modal>
				<div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            
            </div>
              	
		);
    }

}
function loadScript(url){
    var index  =window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src=url
    script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}
                   
function timeConvert(n) {
	var num = n;
	var hours = (num / (3600));
	var rhours = Math.floor(hours);
	var minutes = (n) / (60);
	var rminutes = Math.round(minutes);
	return rhours + " hour(s) and " + rminutes + " minute(s).";
}                              
var currentinfowindow = null;
function getTimeInfo(marker,timedet,coords)
{
	var timeinfo = new window.google.maps.InfoWindow({
          content: "Time at this location: " + timedet
        });

	marker.addListener('click', function() {
		
				if (currentinfowindow != null) {
					currentinfowindow.close();
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				else
				{
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				
        });
}

function parseEventsData2 (jsonData) {
    console.info('parsing data IN parseEventsData');
    console.info('parsing data IN parseConsignemntDetailsSafexpress', jsonData);
   
    let points = jsonData.points;
   // console.log('points = ', points);
    let eventList = [];
    let eventInfo = {};
    points.forEach(function(point) {
        eventInfo.name = point.name;
        eventInfo.country = point.country;
      // traversing events
      if (point.events) {
        console.log('coming in events');
        point.events.forEach(function(eventObj) { 
            eventInfo.event_datetime_ist = eventObj.event_datetime_ist;
            eventInfo.description = eventObj.description;
        });
        eventList.push(eventInfo);
      } else {
        console.log('coming in ELSE point.events ');

      }
      
    });
    console.info('parsing points');

    return eventList;
  }
  
async function parseEventsData (jsonData) {
//console.info('parsing data IN parseEventsData');
//console.info('parsing data IN parseConsignemntDetailsSafexpress', jsonData);

let points = jsonData.points;
// console.log('points = ', points);
let eventList = [];
let eventInfo = [];

points.forEach(function(point) {
	let pointName = point.name;
	let pointCountry = point.country;
	let pointTransportTypeName = point.transport_type_name;
	let pointTransportType = point.type;
	if (pointTransportType === 1 || pointTransportType === 4) {
		pointTransportTypeName = "Rail/Truck";
	}
	if (!pointTransportTypeName) {
		pointTransportTypeName = "Data unavailable"
	}
	// traversing events
	if (point.events) {
		//console.log('coming in events');
		point.events.forEach(function(eventObj) { 
			let eventDatetime = eventObj.event_datetime_ist;
			let eventDescription = eventObj.description;
			
			let initial_event_datetime_ist = eventObj.initial_event_datetime_ist;
            let previous_event_datetime_ist = eventObj.previous_event_datetime_ist;
			let actual_event_datetime_ist	= eventObj.actual_event_datetime_ist;
			

			eventInfo = {
				"name": pointName,
				"country": pointCountry,
				"event_datetime_ist": eventDatetime,
				"description": eventDescription,
				"transport_type_name": pointTransportTypeName,
				"initial_event_datetime_ist": initial_event_datetime_ist,
				"previous_event_datetime_ist": previous_event_datetime_ist,
				"actual_event_datetime_ist": actual_event_datetime_ist,
			}
			eventList.push(eventInfo);
		});
	} else {
		console.log('coming in ELSE point.events '); // do nothing
	}
});
//console.log('eventList', eventList);
return eventList;
}


// function dateComparator(date1, date2) {
//     var date1Number = monthToComparableNumber(date1);
//     var date2Number = monthToComparableNumber(date2);

//     if (date1Number===null && date2Number===null) {
//         return 0;
//     }
//     if (date1Number===null) {
//         return -1;
//     }
//     if (date2Number===null) {
//         return 1;
//     }

//     return date1Number - date2Number;
// }

// // eg 29/08/2004 gets converted to 20040829
// function monthToComparableNumber(date) {
//     if (date === undefined || date === null || date.length !== 10) {
//         return null;
//     }

//     var yearNumber = date.substring(6,10);
//     var monthNumber = date.substring(3,5);
//     var dayNumber = date.substring(0,2);

//     var result = (yearNumber*10000) + (monthNumber*100) + dayNumber;
//     return result;
// }
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}
function dateComparator1(date1,date2){
	//console.log(date1,date2);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split("-")[1]);
	date1 = date1.replace(date1.split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split("-")[1]);
	date2 = date2.replace(date2.split("-")[1],date_2);
	var date1Number = monthToComparableNumber1(date1);
	var date2Number = monthToComparableNumber1(date2);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}	
}

function monthToComparableNumber1(date) {
	console.log(date.length);
	console.log(date);
	if (date === undefined || date === null || date.length !== 10) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

